<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <upload
            @updatedSrc="getSrc"
            :preview="tile"
            @updateTitle="getName"
          ></upload>
        </v-col>

        <v-col cols="12">
           <v-text-field
                class="mt-5"
                label="Title"
                v-model.trim="tile.title"
                type="text"
                placeholder="Tile"
                id="title"
              ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
import { Upload } from "@/components/functionality";

export default {
  name: "AdminTileUpload",
  components: { Upload },
  data() {
    return {
      isValid: true,
    };
  },
  props: {
    tile: Object,
  },
  methods: {
    getSrc(val) {
      this.tile.src = val;
    },
    getName(val) {
      this.tile.title = val;
      this.$nextTick(() => {
        this.tile.title = val;
      });
    },
    validateImage(val) {
      this.isValidImage = val;
    },
  },
};
</script>
